import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Link: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d='M9.0371 9.74705C11.3205 7.68414 14.8454 7.75347 17.0459 9.95408L17.2529 10.1709C19.2492 12.3805 19.2492 15.7532 17.2529 17.9629L17.0459 18.1797L14.1797 21.0459C11.9792 23.2465 8.45432 23.3158 6.17088 21.2529L5.95409 21.0459C3.68246 18.7743 3.68246 15.0919 5.95409 12.8203L6.41795 12.3555C6.71079 12.0627 7.18561 12.0628 7.4785 12.3555C7.75306 12.63 7.7705 13.0648 7.53026 13.3594L7.4785 13.416L7.01463 13.8808C5.3288 15.5666 5.3288 18.2995 7.01463 19.9853L7.17577 20.1387C8.87038 21.6696 11.4861 21.6185 13.1191 19.9853L15.9853 17.1191L16.1387 16.958C17.6202 15.3181 17.6202 12.8156 16.1387 11.1758L15.9853 11.0146C14.3523 9.38149 11.7365 9.33033 10.042 10.8613L9.88085 11.0146L9.67381 11.2217L9.61717 11.2724C9.32269 11.513 8.888 11.4961 8.61327 11.2217C8.32039 10.9288 8.32036 10.453 8.61327 10.1601L8.8203 9.95408L9.0371 9.74705Z'
        fill={fill}
      />
      <path
        d='M10.0371 2.74705C12.3205 0.684177 15.8454 0.753521 18.0459 2.95408L18.2529 3.17088C20.2492 5.38057 20.2492 8.75318 18.2529 10.9629L18.0459 11.1797L17.582 11.6445C17.2892 11.9373 16.8144 11.9372 16.5215 11.6445C16.2286 11.3516 16.2286 10.8769 16.5215 10.584L16.9853 10.1191L17.1387 9.95799C18.6202 8.3181 18.6202 5.81565 17.1387 4.17576L16.9853 4.01463C15.3523 2.38153 12.7365 2.33036 11.042 3.86131L10.8808 4.01463L8.01463 6.88084C6.32879 8.56668 6.3288 11.2995 8.01463 12.9853L8.17577 13.1387C9.87037 14.6696 12.4861 14.6185 14.1191 12.9853L14.3262 12.7783C14.619 12.4856 15.0938 12.4857 15.3867 12.7783C15.6796 13.0712 15.6795 13.5459 15.3867 13.8388L15.1797 14.0459C12.9792 16.2465 9.45432 16.3158 7.17088 14.2529L6.95409 14.0459C4.68245 11.7743 4.68246 8.09192 6.95409 5.82029L9.8203 2.95408L10.0371 2.74705Z'
        fill={fill}
      />
    </svg>
  )
}

export default Link
